var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWarning)?_c('b-navbar-item',{staticClass:"session-countdown",class:{ 'is-urgent': _vm.isUrgent },attrs:{"tag":"div","role":"status"}},[_c('b-icon',{staticClass:"mr-1",attrs:{"icon":"clock-outline"}}),_c('p',[_vm._v("Sitzung läuft in "+_vm._s(_vm.remainingLabel)+" ab")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }